// extracted by mini-css-extract-plugin
export default {"favorites":"Favorites_favorites__ZSyZ8","header":"Favorites_header__5OUSp","cards":"Favorites_cards__0owG3","noFavorites":"Favorites_noFavorites__jVK6B"};